type AgentInfo = {
  denAgentVersion: string;
  region: string;
  stackImageVersion: string;
  machineResourceClass: string;
  machineType: string;
  bitriseCliCommand: string;
  hostName?: string;
  nodeName?: string;
};

type CliInfo = {
  bitriseCliVersion: string;
  logFormatVersion: string;
  secretFilteringMode: boolean;
  secretEnvsFilteringMode: boolean;
  ciMode: boolean;
};

export enum StepSummaryStatus {
  Aborted = 'aborted',
  AbortedWithCustomTimeout = 'aborted_with_custom_timeout',
  AbortedWithNoOutput = 'aborted_with_no_output',
  Failed = 'failed',
  FailedSkippable = 'failed_skippable',
  NotStarted = 'not_started',
  PreparationFailed = 'preparation_failed',
  Skipped = 'skipped',
  SkippedWithRunIf = 'skipped_with_run_if',
  Started = 'started',
  Success = 'success',
}

export type StepSummaryError = {
  message: string;
  code?: number;
};

export type StepSummary = {
  collection?: string;
  errors?: StepSummaryError[];
  finishedAt?: string;
  latestVersion?: string;
  releaseNotes?: string;
  sourceCodeUrl?: string;
  startedAt?: string;
  status: StepSummaryStatus;
  statusReason?: string;
  stepId: string;
  supportUrl?: string;
  title?: string;
  uuid: string;
  version?: string;
  deprecationNotice?: string;
  withGroupUuid?: string;
  stepBundleUuid?: string;
};

export type WorkflowSummary = {
  steps: StepSummary[];
  uuid: string;
  workflowId: string;
};

export type BuildEnvironmentSetup = {
  startedAt?: string;
  finishedAt?: string;
  status: StepSummaryStatus;
};

type BuildLogSummary = {
  appId: string;
  buildId: string;
  agentInfo?: AgentInfo;
  cliInfo?: CliInfo;
  hasBuildEnvironmentSetupLogs?: boolean;
  execution?: {
    buildEnvironmentSetup?: BuildEnvironmentSetup;
    workflows: WorkflowSummary[];
    withGroups?: Record<string, { services?: { image: string }[]; container?: { image: string } }>;
    stepBundles?: Record<string, { id: string; title?: string }>;
  };
  isLogArchived: boolean;
};

export const hasSummaryWorkflows = (summary?: BuildLogSummary) => Boolean(summary?.execution?.workflows.length);

export default BuildLogSummary;
